var __jsx = React.createElement;
import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'next-i18next';
import { Wrapper, List } from './styles';
import Item from './Item';
import { RULE_CODES } from '@spa/shared/constants/rule-codes';
import { formatMoneyPerCountry } from '@spa/shared/utils';
import { getRentalConditions } from '@spa/offer/utils/rentalConditions';
import { getRequirementsList } from '@spa/offer/utils/rentalConditions/formatting';
import { calculateShortTermPenalty } from '@spa/offer/utils/rentalConditions/penalties';
import { showModalAction } from '@spa/shared/store/actions/modal';
import { modalIds } from '@spa/offer/components/Modals/modal-displayer';
import { GENDER_RESTRICTIONS_TO_GENDER_TYPE } from '@spa/shared/constants/restrictionsTypes';
var RentalConditions = function RentalConditions(_ref) {
  var minimumStay = _ref.minimumStay,
    extraGuestsAmountStandardContract = _ref.extraGuestsAmountStandardContract,
    extraGuestsAmountFixedUnitaryContract = _ref.extraGuestsAmountFixedUnitaryContract,
    shortTermPenaltyAmount = _ref.shortTermPenaltyAmount,
    shortTermPenaltyPrice = _ref.shortTermPenaltyPrice,
    gender = _ref.gender,
    extraGuestsFormattedAmount = _ref.extraGuestsFormattedAmount,
    isCouplesAllowed = _ref.isCouplesAllowed,
    petsAllowed = _ref.petsAllowed,
    smokingAllowed = _ref.smokingAllowed,
    overnightGuestsAllowed = _ref.overnightGuestsAllowed,
    requirements = _ref.requirements,
    originsList = _ref.originsList,
    occupationsList = _ref.occupationsList,
    guestGender = _ref.guestGender,
    showGenderRestrictionModal = _ref.showGenderRestrictionModal;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var genderRestriction = gender === null || gender === void 0 ? void 0 : gender[0];
  var allowedGender = GENDER_RESTRICTIONS_TO_GENDER_TYPE[genderRestriction === null || genderRestriction === void 0 ? void 0 : genderRestriction.toUpperCase()];
  var requirementsList = getRequirementsList(requirements, t);
  var rentalConditions = useMemo(function () {
    return getRentalConditions({
      minimumStay: minimumStay,
      shortTermPenaltyAmount: shortTermPenaltyAmount,
      shortTermPenaltyPrice: shortTermPenaltyPrice,
      extraGuestsAmountStandardContract: extraGuestsAmountStandardContract,
      extraGuestsAmountFixedUnitaryContract: extraGuestsAmountFixedUnitaryContract,
      extraGuestsFormattedAmount: extraGuestsFormattedAmount,
      requirementsList: requirementsList,
      petsAllowed: petsAllowed,
      smokingAllowed: smokingAllowed,
      isCouplesAllowed: isCouplesAllowed,
      overnightGuestsAllowed: overnightGuestsAllowed,
      gender: gender,
      originsList: originsList,
      occupationsList: occupationsList,
      t: t
    });
  }, [minimumStay, shortTermPenaltyAmount, shortTermPenaltyPrice, extraGuestsAmountStandardContract, extraGuestsAmountFixedUnitaryContract, extraGuestsFormattedAmount, requirementsList, petsAllowed, smokingAllowed, isCouplesAllowed, gender, originsList, occupationsList, t]);
  useEffect(function () {
    var shouldRenderGenderRestrictionModal = !genderRestriction || !guestGender || allowedGender === guestGender;
    if (shouldRenderGenderRestrictionModal) {
      return;
    }
    showGenderRestrictionModal(genderRestriction);
  }, [guestGender, genderRestriction, allowedGender]);
  return __jsx(Wrapper, {
    id: 'rental-conditions'
  }, __jsx("h2", null, t('Rental Conditions')), __jsx(List, null, rentalConditions.map(function (_ref2, index) {
    var icon = _ref2.icon,
      translationKey = _ref2.translationKey,
      translationValues = _ref2.translationValues,
      content = _ref2.content,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? '' : _ref2$className;
    var Icon = icon;
    var text = t(translationKey, translationValues);
    return __jsx(Item, {
      key: index,
      icon: Icon ? __jsx(Icon, null) : null,
      text: text,
      className: className
    }, content);
  })));
};
var mapStateToProps = function mapStateToProps(_ref3) {
  var _offerAggregate$prope, _offerAggregate$prope2, _contract$standard, _contract$standard$ex, _contract$standard2, _contract$standard2$e, _propertyAggregate$pr, _propertyAggregate$pr2, _propertyAggregate$pr3, _propertyAggregate$pr4, _profile$profile, _profile$profile$basi, _contract$fixed_unita, _contract$fixed_unita2;
  var offerAggregate = _ref3.offer.offerAggregate,
    profile = _ref3.profile;
  var accommodationOffer = offerAggregate.accommodation_offer;
  var propertyAggregate = offerAggregate.property_aggregate;
  var _ref4 = accommodationOffer || {},
    _ref4$requisites = _ref4.requisites;
  _ref4$requisites = _ref4$requisites === void 0 ? {} : _ref4$requisites;
  var conditions = _ref4$requisites.conditions,
    requirements = _ref4$requisites.requirements,
    _ref4$restrictions = _ref4.restrictions;
  _ref4$restrictions = _ref4$restrictions === void 0 ? {} : _ref4$restrictions;
  var gender = _ref4$restrictions.gender,
    occupancy = _ref4$restrictions.occupancy,
    _ref4$price = _ref4.price;
  _ref4$price = _ref4$price === void 0 ? {} : _ref4$price;
  var referencePrice = _ref4$price.reference,
    contract = _ref4.contract;
  var rules = (offerAggregate === null || offerAggregate === void 0 ? void 0 : (_offerAggregate$prope = offerAggregate.property_aggregate) === null || _offerAggregate$prope === void 0 ? void 0 : (_offerAggregate$prope2 = _offerAggregate$prope.property) === null || _offerAggregate$prope2 === void 0 ? void 0 : _offerAggregate$prope2.rules) || [];
  var extraGuestAmount = (contract === null || contract === void 0 ? void 0 : (_contract$standard = contract.standard) === null || _contract$standard === void 0 ? void 0 : (_contract$standard$ex = _contract$standard.extra_per_guest) === null || _contract$standard$ex === void 0 ? void 0 : _contract$standard$ex.amount) || 0;
  var extraGuestCurrency = (contract === null || contract === void 0 ? void 0 : (_contract$standard2 = contract.standard) === null || _contract$standard2 === void 0 ? void 0 : (_contract$standard2$e = _contract$standard2.extra_per_guest) === null || _contract$standard2$e === void 0 ? void 0 : _contract$standard2$e.currency_code) || (referencePrice === null || referencePrice === void 0 ? void 0 : referencePrice.currency_code);
  var extraGuestsFormattedAmount = formatMoneyPerCountry(extraGuestAmount, extraGuestCurrency);
  var _calculateShortTermPe = calculateShortTermPenalty(accommodationOffer),
    shortTermPenaltyAmount = _calculateShortTermPe.shortTermPenaltyAmount,
    shortTermPenaltyPrice = _calculateShortTermPe.shortTermPenaltyPrice;
  var originsList = propertyAggregate === null || propertyAggregate === void 0 ? void 0 : (_propertyAggregate$pr = propertyAggregate.property) === null || _propertyAggregate$pr === void 0 ? void 0 : (_propertyAggregate$pr2 = _propertyAggregate$pr.restrictions) === null || _propertyAggregate$pr2 === void 0 ? void 0 : _propertyAggregate$pr2.origin;
  var occupationsList = propertyAggregate === null || propertyAggregate === void 0 ? void 0 : (_propertyAggregate$pr3 = propertyAggregate.property) === null || _propertyAggregate$pr3 === void 0 ? void 0 : (_propertyAggregate$pr4 = _propertyAggregate$pr3.restrictions) === null || _propertyAggregate$pr4 === void 0 ? void 0 : _propertyAggregate$pr4.occupation;
  var getRuleValue = function getRuleValue(rules, ruleCode) {
    var _rules$find;
    return Array.isArray(rules) && ((_rules$find = rules.find(function (rule) {
      return rule.code === ruleCode;
    })) === null || _rules$find === void 0 ? void 0 : _rules$find.exists) || false;
  };
  var guestGender = profile === null || profile === void 0 ? void 0 : (_profile$profile = profile.profile) === null || _profile$profile === void 0 ? void 0 : (_profile$profile$basi = _profile$profile.basic_info) === null || _profile$profile$basi === void 0 ? void 0 : _profile$profile$basi.gender;
  return {
    minimumStay: conditions === null || conditions === void 0 ? void 0 : conditions.minimum_nights,
    shortTermPenaltyAmount: shortTermPenaltyAmount,
    shortTermPenaltyPrice: shortTermPenaltyPrice,
    extraGuestsAmountStandardContract: extraGuestAmount,
    extraGuestsAmountFixedUnitaryContract: (contract === null || contract === void 0 ? void 0 : (_contract$fixed_unita = contract.fixed_unitary) === null || _contract$fixed_unita === void 0 ? void 0 : (_contract$fixed_unita2 = _contract$fixed_unita.extra_per_guest) === null || _contract$fixed_unita2 === void 0 ? void 0 : _contract$fixed_unita2.amount) || 0,
    extraGuestsFormattedAmount: extraGuestsFormattedAmount,
    gender: gender,
    isCouplesAllowed: !(occupancy !== null && occupancy !== void 0 && occupancy.find(function (couples) {
      return couples === 'couples';
    })) && (conditions === null || conditions === void 0 ? void 0 : conditions.max_guests) > 1,
    petsAllowed: getRuleValue(rules, RULE_CODES.PETS_ALLOWED),
    smokingAllowed: getRuleValue(rules, RULE_CODES.SMOKING_ALLOWED),
    overnightGuestsAllowed: getRuleValue(rules, RULE_CODES.OVERNIGHT_GUESTS_ALLOWED),
    requirements: {
      contract: requirements === null || requirements === void 0 ? void 0 : requirements.contract,
      guarantor: requirements === null || requirements === void 0 ? void 0 : requirements.guarantor,
      offlineId: requirements === null || requirements === void 0 ? void 0 : requirements.offline_id,
      occupation: requirements === null || requirements === void 0 ? void 0 : requirements.occupation
    },
    originsList: originsList,
    occupationsList: occupationsList,
    guestGender: guestGender
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    showGenderRestrictionModal: function showGenderRestrictionModal(genderRestriction) {
      return dispatch(showModalAction({
        modalId: modalIds.GENDER_RESTRICTION,
        genderRestriction: genderRestriction
      }));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(RentalConditions);